import styled from 'styled-components';
import { IoFolderOpenOutline } from 'react-icons/io5';

import useDownload from './hooks/useDownload';
import ExtensionButton from './components/ExtensionButton';
import Button from 'components/ui/Button';

const Container = styled.div`
  padding: 18px;
`;

const Title = styled.label`
  display: block;
  margin-bottom: 10px;
`;

const ExtensionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
`;

const DownloadMenu = () => {
  const { selectedFileExtension, isPending, onDownloadClick, onFileExtensionChage } = useDownload();

  return (
    <Container>
      <Title>다운로드 형식</Title>
      <ExtensionList>
        <ExtensionButton
          isSelected={selectedFileExtension === 'zip'}
          Icon={IoFolderOpenOutline}
          extension="zip"
          title="프로젝트"
          description="소스코드를 포함한 프로젝트 폴더 구조 전체를 다운로드해요"
          onClick={() => onFileExtensionChage('zip')}
        />
        <ExtensionButton
          isSelected={selectedFileExtension === 'py'}
          Icon={IoFolderOpenOutline}
          extension="py"
          title="Python"
          description=".py 확장자의 Python 파일로 소스코드를 다운로드해요"
          onClick={() => onFileExtensionChage('py')}
        />
        <ExtensionButton
          isSelected={selectedFileExtension === 'ipynb'}
          Icon={IoFolderOpenOutline}
          extension="ipynb"
          title="Jupyter Notebook"
          description=".ipynb 확장자의 Jupyter Notebook 파일로 소스코드를 다운로드해요"
          onClick={() => onFileExtensionChage('ipynb')}
        />
      </ExtensionList>
      <Button $isFillWidth $height={46} $isLoading={isPending} onClick={onDownloadClick}>
        다운로드
      </Button>
    </Container>
  );
};

export default DownloadMenu;
